import React from 'react';
import classNames from 'classnames';
import { CollapsibleSection } from 'components/CollapsibleSection';
import { useTranslation } from 'react-i18next';

import './LeadContext.styles.scss';

type LeadContextProps = {
  className?: string;
  context?: string;
};

const LeadContext: React.FC<LeadContextProps> = (props) => {
  const { className, context } = props;

  const classes = classNames('lead-context', className);

  const { t } = useTranslation();

  if (!context) return null;

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <CollapsibleSection className={classes} trigger={t('context')}>
        {context}
      </CollapsibleSection>
    </div>
  );
};

export default LeadContext;
